import React, { useEffect, useState } from 'react';
import {
  Box,
  Image,
  Text,
  SimpleGrid,
  VStack,
  Spinner,
  CircularProgress,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { apiEndPoint } from './StaticVar';
import MyLoading from './MyLoading';

function ImageList(props) {
  const [data, setData] = useState()
    const [loading, setLoading] = useState(true)
    const params = useParams();
    useEffect(() => {
      getPhotos()
    }, [])
  
    const getPhotos = async () => {
      const response = await fetch(apiEndPoint + "/api/image_collections/"+params.photoId);
      const json = await response.json();
      setData(json);
      console.log(params);
      setLoading(false);
    }
  
  return (
    loading ? <MyLoading /> : <Box padding={4}>
      <Text alignSelf="start" fontSize={32}>{data["name"]}</Text>
      <br></br>
      <SimpleGrid columns={[1, 2, 3]} spacing={4}>
        {data["image_urls"].map((image, index) => (
          <VStack key={index} spacing={2} align="center">
            <Image src={apiEndPoint + "/" + image} borderRadius="lg" />
            {/* <Text alignSelf="start">{image.description}</Text> */}
          </VStack>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default ImageList;